import { FormActions } from "../../components/Form";
export const SampleActions = {
  LOAD_DATA: "load-data",
};
export default function SampleReducer(state, action) {
  if (action.type === FormActions.INPUT_CHANGED) {
    return { ...state, [action.payload.name]: action.payload.value };
  }
  if (action.type === SampleActions.LOAD_DATA) {
    return action.payload;
  }
  return state;
}
